export function convertBalance(
    balance: number,
    course: number | string,
    operator: 'multiply' | 'divide' = 'multiply',
): number {
    const rate = Number(course);
    if (!rate || Number.isNaN(rate)) return 0;
    const value = operator === 'divide' ? balance / rate : balance * rate;
    // округление вниз до 2 знаков
    return Math.floor(value * 100) / 100;
}
